(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["guide-step"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.guideStepAddBound) return;
    window.guideStepAddBound = true;

    // One delegated listener for every step's add button.
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-guide-add]');
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;

      button.setAttribute('aria-busy', 'true');
      fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.guideAdd, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function () {
          button.textContent = button.dataset.added;
          button.disabled = true;
          // The cart drawer listens for this, refreshes and opens.
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(function () {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
        })
        .finally(function () {
          button.removeAttribute('aria-busy');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.productBundleAddBound) return;
    window.productBundleAddBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-product-bundle-add]');
      if (!button || button.disabled) return;

      var ids = button.dataset.productBundleAdd.split(',');
      // The first id is this product: follow the variant picked in the form.
      var picked = document.querySelector('.product-form [name="id"]');
      if (picked && picked.value) ids[0] = picked.value;

      // aria-busy drives the spinner, as on the product form's button.
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) {
            return { id: Number(id), quantity: 1 };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.json();
        })
        .then(function () {
          // The cart drawer listens for this, refreshes and opens.
          document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(function () {
          window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
        })
        .finally(function () {
          button.removeAttribute('aria-busy');
          button.disabled = false;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-fact"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('models-drawer')) return;

    class ModelsDrawer extends HTMLElement {
      connectedCallback() {
        /*
         * On desktop the buy box is a sticky column with its own z-index, a
         * stacking context that would keep the drawer under the sticky header.
         * So it moves itself to <body>, like the other drawers, which live
         * there already. A copy left by a theme-editor re-render is replaced.
         * Moving it reconnects it, and the second pass does the set-up.
         */
        if (this.parentElement !== document.body) {
          var stale = document.body.querySelector(':scope > models-drawer#' + CSS.escape(this.id));
          if (stale && stale !== this) stale.remove();
          document.body.appendChild(this);
          return;
        }
        if (this.ready) return;
        this.ready = true;

        this.overlay = this.querySelector('.models-drawer__overlay');
        this.closeButton = this.querySelector('.models-drawer__close');
        this.onKeydown = this.onKeydown.bind(this);

        this.trigger = document.querySelector('[data-models-drawer-open="' + this.id + '"]');
        this.trigger?.addEventListener('click', () => this.openDrawer());
        this.closeButton?.addEventListener('click', () => this.close());
        this.overlay?.addEventListener('click', () => this.close());
      }

      openDrawer() {
        this.setAttribute('open', '');
        this.removeAttribute('inert');
        this.setAttribute('aria-hidden', 'false');
        this.trigger?.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', this.onKeydown);
        this.closeButton?.focus();
      }

      close() {
        this.removeAttribute('open');
        this.setAttribute('inert', '');
        this.setAttribute('aria-hidden', 'true');
        this.trigger?.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', this.onKeydown);
        this.trigger?.focus();
      }

      onKeydown(event) {
        if (event.key === 'Escape') this.close();
      }
    }

    customElements.define('models-drawer', ModelsDrawer);
  })();
  } catch(e) { console.error(e); }
})();

})();
